module.exports = __webpack_public_path__ + "static/media/banner_02.afc76969.png";